import { EnvironmentConfiguration } from '@/config/environments/environment-configuration'
import { config as config_17_ziele_konstanz_de } from '@/config/environments/www.17ziele-konstanz.de'
import { config as config_test_respondeco_org } from '@/config/environments/test.respondeco.org'
import { config as config_www_respondeco_org } from '@/config/environments/www.respondeco.org'
import config_other from '@/config/environments/other'
import { StringMap } from '@/shared/utils/map'

const hosts: StringMap<EnvironmentConfiguration> = {
  '17ziele.test:8080': config_17_ziele_konstanz_de,
  'www.17ziele-konstanz.de': config_17_ziele_konstanz_de,
  'test.respondeco.org': config_test_respondeco_org,
  'www.respondeco.org': config_www_respondeco_org,
}

export function environmentConfiguration(): EnvironmentConfiguration {
  return hosts[location.host] || config_other
}

/**
 * It is possible that respondeco is used for the documentation of a project (e.g. 17 Ziele fuer
 * Konstanz). If this is the case, certain parts of the platform will be shown or hidden, depending
 * on the project.
 */
export function isRespondeco(): boolean {
  return environmentConfiguration().branding === null
}
